angular.module('lf.common')

.directive('csFormRecaptcha', function ($timeout) {
  return {
    restrict: 'A',
    require: '^form',
    scope: {
      response: '=?ngModel',
    },
    link: function link (scope, el, attrs, ctrl) {
      var recaptcha = window.grecaptcha;
      
      window.onRecaptchaLoaded = function () {
        recaptcha = window.grecaptcha;
        render();
      }
      
      if (recaptcha) render();
      
      ctrl.$setValidity('recaptcha', false);
      
      function render () {
        recaptcha.render(el[0], {
          sitekey: attrs.key,
          callback: onSuccess,
          'expired-callback': onExpired
        });
      }
      
      function onSuccess (response) {
        $timeout(function () {
          ctrl.$setValidity('recaptcha', true);
          scope.response = response;
        });
      }
      
      function onExpired () {
        $timeout(function () {
          ctrl.$setValidity('recaptcha', false);
          scope.response = '';
        });
      }
      
      scope.$on('$destroy', function () {
        ctrl.$setValidity('recaptcha', null);
      });
    }
  }
});
